var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('section',{attrs:{"id":"development"}},[_c('span',{staticClass:"alert"},[_vm._v("Entorn de proves")]),_c('span',{staticClass:"date"},[_vm._v("Última actualització: "),_c('strong',[_vm._v(_vm._s(_vm.date))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }